import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {
  selectedFile: any;
  selectedFileName: any;
  loading: boolean;
  successfullySentMessage: any;
  uploading: boolean;
  FromId: any;
  subName: any;
  subMobile: any;
  message: any;
  data: any;
  attachmentDataArray = [];
  attachmentData: { "name": any; "size": any; "type": any; };
  fileArray = [];
  fileNameArray = [];
  uploader: any;
  minLengthError: boolean = false;
  mailSubject: string;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    this.FromId = localStorage.getItem("email");
    this.subName = localStorage.getItem("name");
    this.subMobile = localStorage.getItem("mobileNumber");
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0]
    // console.log(event.target.files);
    const supportedExtensions = ['jpeg', 'jpg', 'png', 'zip', 'pdf', 'doc','docx', 'dox', 'xls','xlsx'];
    var eventTarget = event.target
      const path = eventTarget.value.split('.');
      
      const extension = `${path[path.length - 1]}`;
      if (supportedExtensions.includes(extension)) {
        //upload
         /* For max and min file size start */
        if(this.selectedFile.size < 10000 || this.selectedFile.size > 15000000){
          var toaster = document.getElementById("snackbar");
          toaster.innerHTML = "File should be more than 10KB and less than 15MB in size";
          toaster.className = "show";
          setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
          return
          /* For max and min file size end */
        }else{
          this.uploading = true;
          if (event.target.files && event.target.files[0]) {
            var filesAmount = event.target.files.length;
            for (let i = 0; i < filesAmount; i++) {         
              /* For max 15 files Files acceptance */
              if ((this.fileArray.length) < 15){
                var uploadedFileName = event.target.files[i].name
                this.fileNameArray.push(uploadedFileName)

                var uploadedFile = event.target.files[i]
                this.fileArray.push(uploadedFile)
              }else{
                var toaster = document.getElementById("snackbar");
                toaster.innerHTML = "You can only upload a maximum of 15 files";
                toaster.className = "show";
                setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
              }
            }
          }
          setTimeout(() => {
            this.uploading = false;
            this.selectedFileName = this.selectedFile.name;
          }, 1000);
        }
      } else {
          //  show "invalid file type" message to user
          var toaster = document.getElementById("snackbar");
                toaster.innerHTML = "Invalid File type";
                toaster.className = "show";
                setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
          // reset value
          event.value = '';
      }
   
  }

  removeSelectedFile(index) {
    // Delete the item from fileNames list
    this.fileNameArray.splice(index, 1);
    // delete file from FileList
    this.fileArray.splice(index, 1);
   }

  sentEmail() {
    if (String(this.message).length < 50) {
      var toaster = document.getElementById("snackbar");
      toaster.innerHTML = "Your message should contain atleast 50 characters.";
      toaster.className = "show";
      setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
    }else if(String(this.message).length > 5000){
      var toaster = document.getElementById("snackbar");
      toaster.innerHTML = "Your message should contain maximum 5000 characters.";
      toaster.className = "show";
      setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, 3000);
    }else{
      const fileSelected: File = this.selectedFile;

      const formData: FormData = new FormData();
      // formData.append('file', this.selectedFile, this.selectedFileName);
      if (this.selectedFile) {
        for (let i = 0; i < this.fileArray.length; i++) {
          formData.append('file', this.fileArray[i], this.fileArray[i].name);
        }
      } else {
        this.attachmentDataArray = [];
      }
      this.loading = true;
      formData.append('message', this.message);
      if (this.subName == "null") {
        this.subName = ""
      }
      this.mailSubject = this.subName + '-' + this.subMobile;
      formData.append('subject', this.mailSubject);
      this.data = {
        "message": (this.message),
        "file": (formData),
        "subject": (this.mailSubject)
      }
      this.serviceURLService.sentEmail(formData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.loading = false;
        this.successfullySentMessage = successData.message;
        $("#emailSentModal").modal("show");
      }, errorData => {
        if (errorData.error.status === 401) {
          localStorage.clear();
          alert("Login session has been expired..!! Please Login again.")
          this.router.navigate(['login']);
        }
        console.log("Error");
      })
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    
}
